import React, { useState } from "react";
import { Toast } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setToastes } from "StoreRedux/Slice/ToastSlice";
import { tiempoLectura } from "./tiempoLectura";

// Notificacion general del panel (setToastes). Se cierra sola despues del tiempo de lectura del
// mensaje; mientras el mouse esta encima no se cierra. Antes tenia autohide pero sin onClose: como
// "show" viene de Redux, nadie lo ponia en false y quedaba en pantalla para siempre.
const ToastViews = () => {
    const usedispatch = useDispatch()
    let selector = useSelector((state) => state.ToastSlice.toastmsg)
    const [encima, setEncima] = useState(false)
    function cerrar() {
        usedispatch(setToastes({ show: false, message: '', color: '', estado: '' }))
    }
    return (<>

        <Toast
            // Mensaje nuevo = toast nuevo (reinicia el tiempo aunque ya hubiera uno abierto)
            key={`${selector.estado}|${selector.message}`}
            show={!!selector.show} onClose={cerrar}
            autohide={!encima} delay={tiempoLectura(selector.estado, selector.message)}
            onMouseEnter={() => setEncima(true)} onMouseLeave={() => setEncima(false)}

            className="top-center"
            style={{
                position: 'fixed',
                top: 80,
                right: 2,
                transform: 'translate(-50 %, 0 %)',
                zIndex: 100000,
            }}>
            <Toast.Header closeButton={false}>
                <div className={selector.color + " rounded-3"} style={{ width: '20px', height: '20px', }}></div>
                <strong className="mr-auto  px-1">{selector.estado} </strong>
                <small></small>
                <button type="button" className="close"
                    onClick={cerrar} >
                    ×
                </button>

            </Toast.Header>
            <Toast.Body className={selector.color + " text-white"} >{selector.message}</Toast.Body>
        </Toast>
    </>)
}
export default ToastViews
